import noop from 'utils/noop';

import { IStorePrepaidCard } from './types';

export const storePrepaidCard = noop as (options: IStorePrepaidCard) => void;
